import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { AuthenticationService } from '../_services/authentication.service';
import { environment } from '../../../environments/environment';
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.less'],
})
export class CaptchaComponent implements OnInit, OnDestroy {

  @Input() form: UntypedFormGroup;
  @Output() resolved: EventEmitter<boolean> = new EventEmitter();

  CAPTCHA_SITE_KEY = '6LemIAoaAAAAAMSySp1M6r3Vea7IWou2W8j1StIg';
  env = environment;
  isVerifyingInternally = false;

  private unsubscribe$ = new Subject<void>();

  constructor(private authService: AuthenticationService) { }

  ngOnInit() {
    RecaptchaComponent.prototype.ngOnDestroy = () => {};
  }

  captchaResolved(captchaRes: string): void {
    let isCaptchaVerified = false;
    if (captchaRes) {
      this.isVerifyingInternally = true;
      this.authService.isCaptchaTokenValid(captchaRes).pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => this.isVerifyingInternally = false),
      )
        .subscribe(res => {
            isCaptchaVerified = res === true;
            this.form.get('captcha').setValue('validated');
            this.resolved.emit(isCaptchaVerified);
          },
          () => {
            isCaptchaVerified = false;
            this.resolved.emit(isCaptchaVerified);
          }
        );
    } else {
      isCaptchaVerified = false;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
